export class NombrePila {
    [key: string]: string | number | undefined
    public id: number | undefined;
    public nombre: string | undefined;
    public sexo: string | undefined;
}